import axios from 'axios'
import route from '../router'

// 导出Excel公用方法
export function exportMethod(data) {
  axios({
    method: data.method,
    url: `${data.url}${data.params ? '?' + data.params : ''}`,
    responseType: 'blob'
  }).then((res) => {
    const link = document.createElement('a')
    let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    //获取heads中的filename文件名
    let fileName = res.headers["content-disposition"].split(";")[1].split("filename=")[1];
    console.log(fileName, 4444);
    link.download = decodeURI(fileName) //下载后文件名
    //link.download = data.fileName //下载的文件名
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }).catch(error => {
    this.$Notice.error({
      title: '错误',
      desc: '网络连接错误'
    })
    console.log(error)
  })
}

//加操作日志headers头公用方法
export function addApplogFn(log, currentRoute) {
  // if (formTableName && formTableName.indexOf("div") > -1) {
  //   var index = formTableName.indexOf("审批单");
  //
  //   if (index < 0) {
  //     index = formTableName.indexOf("申报表");
  //   }
  //
  //   if (index < 0) {
  //     index = formTableName.indexOf("申请单");
  //   }
  //
  //   var beforeStr = formTableName.substring(0, index);
  //   var beforeStrIndex = beforeStr.lastIndexOf(">");
  //   formTableName = beforeStr.substring(beforeStrIndex + 1, index) + "审批单";
  // }
  //
  // var formName = formTableName; //获取传递过来的表单名
  //
  // if (!formName) {
  //   formName = $("#blueBorderTable").find("tr:first td").text().trim(); //获取表格中的表单名
  // }
  //
  // if (!formName) {
  //   //获取弹窗title上的表单名
  //   var strIndex = $(".layui-layer-title").text().indexOf("[") + 1;
  //   var endIndex = $(".layui-layer-title").text().indexOf("]");
  //   formName = $(".layui-layer-title").text().substring(strIndex, endIndex);
  // }
  //
  // if (formName && formName.indexOf("[") != -1 && formName.indexOf("]") != -1) {
  //   var strIndex = formName.indexOf("[") + 1;
  //   var endIndex = formName.indexOf("]");
  //   formName = formName.substring(strIndex, endIndex);
  // }
  var busKey = log[1]||"发起了";
  var des = log[0] || "";
  // des = des + formName;

  if (des && des.length > 0) {
    busKey = busKey + "：" + des;
  }

  var applogcontent = base64Encode(busKey); //实时获取

  var back = findShowMenuName(currentRoute);

  if(!back){
    back = "大屏展示"
  }

  var applogheader = JSON.parse("{\"applogcontent\":\"" + applogcontent + "\",\"pagename\":\"" + base64Encode(back) + "\"}");
  return applogheader;
}

export function base64Encode(input) {
  var rv;
  rv = encodeURIComponent(input);
  rv = unescape(rv);
  rv = window.btoa(rv);
  return rv;
}

export function findShowMenuName(formTableName) {
  return formTableName.meta?formTableName.meta.title:"——";
}
//循环递归转义字符
export function deepHtmlDecodeByRegExp(source) {
  if (!source || typeof source !== 'object' || typeof source === 'string') {
    return htmlDecodeByRegExp(source);
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepHtmlDecodeByRegExp(source[keys])
    } else {
      targetObj[keys] = htmlDecodeByRegExp(source[keys])
    }
  })
  return targetObj
}
//转义解析HTML编码
/**
 * HTML转义字符逆转义（适配若依框架存储的富文本内容）
 * @param {string | number | null | undefined} str - 待逆转义的字符串（兼容非字符串类型）
 * @returns {string | number | null | undefined} 逆转义后的内容（保持原始类型）
 */
export function htmlDecodeByRegExp(str) {
  // 1. 边界值处理：null/undefined/数字直接返回（兼容空值和数字类型）
  if (str === null || str === undefined || typeof str === 'number') {
    return str;
  }
  // 2. 强制转为字符串（避免传入布尔值/对象等非字符串类型导致报错）
  const targetStr = String(str);
  // 3. 批量替换转义字符（用正则表达式一次性替换，性能更优）
  // 注意：先替换&amp;（&的转义），再替换其他依赖&的转义符，避免替换不彻底
  const escapeMap = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&nbsp;': ' ',
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"', // 补充双引号的另一种转义形式
    '&#92;': '\\' // 补充反斜杠转义（可选，根据你的业务场景）
  };
  // 构建正则表达式（匹配所有转义符）
  const reg = new RegExp(Object.keys(escapeMap).join('|'), 'g');
  // 执行替换
  return targetStr.replace(reg, (match) => escapeMap[match]);
}
//递归逆转义特殊字符
export function replaceData(data) {
  if (typeof data === 'string') {
    // 使用正则表达式将 'apple' 替换为 'orange'
    const replacedData = htmlDecodeByRegExp(data);
    return replacedData
  } else if (Array.isArray(data)) {
    // 如果是数组，则对数组中的每个元素递归调用 replaceData 函数
    return data.map(item => replaceData(item))
  } else if (typeof data === 'object' && data !== null) {
    // 如果是对象，则对对象中的每个属性递归调用 replaceData 函数
    const replacedData = {}
    for (const key in data) {
      const value = data[key]
      replacedData[key] = replaceData(value)
    }
    return replacedData
  } else {
    // 如果不是字符串、数组或对象，则直接返回原始数据
    return data
  }
}
export function setStorageItem(k, v) {
  if(typeof(v) == "undefined" || v == null){
    return;
  }

  let val = v;
  if(typeof(v) == "object"){
    val = JSON.stringify(v);
  }
  localStorage.setItem(k, val)
}